import { ExtendsMainComponent } from '../extends/extends-main.component';

import { ConsentComponent } from './consent.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { DisplayService } from '../../service/display.service';

import { AuthService } from '../../service/auth.service';
import { environment } from '../../../environments/environment';

declare let gtag: any; // グローバル変数gtagを解決

export class ConsentMainComponent extends ExtendsMainComponent {
  private confirmModal: ConfirmModalComponent;
  private waitModal: WaitModalComponent;
  private consentComponent: ConsentComponent;

  private authService: AuthService;

  // V2の判定
  public isV2: boolean;

  // 画面項目定義
  public clientName: string;
  public clientLogoUri: string;
  public scopes: string[];
  public oidcScopes: string[];
  public displayResourceName: string;
  /** リソース表示名(複数) */
  public displayResourceNames: string[];

  public dispZ0002: string;
  public dispZ0001: string;

  init(_consentComponent: ConsentComponent, _authService: AuthService,
    _waitModal: WaitModalComponent, _confirmModal: ConfirmModalComponent) {

    this.config();

    this.consentComponent = _consentComponent;
    this.authService = _authService;
    this.waitModal = _waitModal;
    this.confirmModal = _confirmModal;

    this.clientName = this.consentComponent.clientName;
    this.clientLogoUri = this.consentComponent.clientLogoUri;
    this.scopes = this.consentComponent.scopes;
    this.oidcScopes = this.consentComponent.oidcScopes;
    this.displayResourceName = this.consentComponent.displayResourceName;
    this.displayResourceNames = this.consentComponent.displayResourceNames;

    this.dispZ0001 = this.consentComponent.dispZ0001;
    this.dispZ0002 = this.consentComponent.dispZ0002;

    this.isV2 = this.authService.isV2;
  }

  /**
   * イベント：次へ
   *
   */
  next() {
    // 引継ぎ項目
    this.consentComponent.pageNo++;

    // 画面切り替え
    this.consentComponent.directInjection();
  }

  /**
   * イベント：戻る
   */
  back() {
    // 引継ぎ項目
    this.consentComponent.pageNo--;

    // 画面切り替え
    this.consentComponent.directInjection();
  }

  /**
   * ユーザの同意可否をFormSubmitするメソッドです.
   * @param result ユーザの選択結果
   */
  submit(result: string) {
    this.waitModal.showModal();

    // 送信先URL
    let url = '';
    if (this.isV2) {
      url = environment.apiServerBaseUrl + '/v2/authorization/receiveconsent?' + TokenManager.getToken();
    } else {
      url = environment.apiServerBaseUrl + '/authorization/receiveconsent?' + TokenManager.getToken();
    }

    // パラメータ
    const param = { 'result': result };

    // submit実行
    this.onSubmit(url, param);

    this.waitModal.hideModal();
  }

  /**
   * 認可同意の処理を行うメソッドです．
   */
  consent() {
    this.submit('consent');
    // GAで集計する
    gtag('event', 'consent');
  }

  /**
   * 認可拒否の処理を行うメソッドです．
   */
  deny() {
    let message = '';
    this.consentComponent.translateService.get('DENY_CONFIRMATION').subscribe((res: string) => {
      message = res;
    });
    let button = '';
    this.consentComponent.translateService.get('DENY').subscribe((res: string) => {
      button = res;
    });
    this.confirmModal.showConfirmModal(message, button).subscribe(
      result => {
        if (result) {
          this.submit('deny');
        }
      }
    );
  }
}
